<template>
	<div class="ld-panel-title">
		<router-link to="/template" class="back-btn"><span></span>模板详情</router-link>
	</div>
	<div class="ld-panel-main">
		<el-descriptions :column="2" border>
			<el-descriptions-item label="模板ID">{{detailData.template_id}}</el-descriptions-item>
			<el-descriptions-item label="模板名称">{{detailData.name}}</el-descriptions-item>
			<el-descriptions-item label="版本">{{detailData.version}}</el-descriptions-item>
			<el-descriptions-item label="创建时间">{{detailData.create_time}}</el-descriptions-item>
		</el-descriptions>
		<el-table border :data="tableData" v-if="tableData">
			<el-table-column property="name" label="参数名称" />
			<el-table-column property="value_type" label="值类型" />
			<el-table-column property="value" label="参数值" width="200">
				<template #default="scope">
					<span v-if="detailData.template_type == '系统模板'">{{scope.row.value}}</span>
					<div v-else>
						<div v-if="scope.row.editType">
							<span>{{scope.row.value}}</span>
							<el-icon size="16" style="float: right; cursor: pointer;" @click="handleEdit(scope.row)"><Edit /></el-icon>
						</div>
						<div v-else>
							<el-input v-model="scope.row.value" style="width: 80%;"></el-input>
							<el-button link type="primary" size="small" @click="editClick(scope.row)">确定</el-button>
						</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column property="type" label="应用类型" />
			<el-table-column property="data_type" label="数据类型" />
			<el-table-column property="source" label="参数源" />
		</el-table>
	</div>
</template>

<script setup>
	import { ref,reactive,onMounted } from 'vue';
	import { parDetail } from '@/api/template';
	import { useRouter } from 'vue-router';
	import { parEdit } from '@/api/template';
    import { Edit } from '@element-plus/icons-vue';

	const router = useRouter();
	const loading = ref(true);
	const template_id = ref('');
	const detailData = ref('');
	const tableData = ref();
	
	const fetchDetailF = () => {
		const param = {
			'template_id':template_id.value
		}
		parDetail(param).then((res) => {	
			detailData.value = res.data;
			const data = res.data.details;
			for (var i = 0; i < data.length; i++) {
				data[i].editType = true;
			}
			tableData.value = data;
			loading.value = false
		})
	};
	const handleEdit = (row) => {
		row.editType = !row.editType;
	}
	const editClick = (row) => {
		const param = row
		parEdit(param).then((res) => {
			if(res.code === 200){
				fetchDetailF()
			}
		})
	}
	
	onMounted(() => {
		if(router.currentRoute.value.query){
			template_id.value = router.currentRoute.value.query.id
		}
		fetchDetailF()
	});
	
</script>

<style lang="scss" scoped>
	::v-deep(.el-descriptions){margin-bottom: 20px;}
	::v-deep(.el-descriptions__label) {width: 120px;}
</style>